import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { PackageState } from '../../Slice/Dashboard/PackageSlice';
import { PaymentState } from '../../Slice/Dashboard/PaymentSlice';
import { completePaymentAPI, createOrderAPI } from '../../ApiCalls/Dashboard/PaymentAPI';
import { showErrorToast, showSuccessToast } from '../../../components/atoms/Utlis/Toast';
import { trackClarityEvent } from '../../../analytics/ClarityAnalytics';
import { CLARITY_EVENTS } from '../../../analytics/EventTypes';


export const PaymentReducer = (builder: ActionReducerMapBuilder<PaymentState>) => {
    builder.addCase(createOrderAPI.pending, (state) => {
        state.loading = true;
    })
        .addCase(createOrderAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            state.order = action.payload;
            console.log(action.payload);
            trackClarityEvent(CLARITY_EVENTS.SUBSCRIPTION_PAYMENT_STARTED, {
                storage_plan_id: action.meta?.arg?.storage_plan_id,
                duration: action.meta?.arg?.duration,
                settlement_for: action.meta?.arg?.settlement_for,
                amount: action.payload?.amount,
            })
        }).addCase(createOrderAPI.rejected, (state, action: PayloadAction<any>) => {

            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(completePaymentAPI.pending, (state) => {
            state.loading = true;
        })
        .addCase(completePaymentAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            console.log("payment completed")
            state.paymentSuccess = true;
            showSuccessToast("Payment successful.")
            trackClarityEvent(CLARITY_EVENTS.SUBSCRIPTION_PAYMENT_COMPLETED, {
                plan_id: action.meta?.arg?.plan_id,
                amount: action.meta?.arg?.amount,
                duration: action.meta?.arg?.yearly_plan ? 12 : 1,
                settlement_for: action.meta?.arg?.settlement_for,
            })
        }).addCase(completePaymentAPI.rejected, (state, action: any) => {

            state.loading = false;
            state.isError = true;
            trackClarityEvent(CLARITY_EVENTS.SUBSCRIPTION_PAYMENT_FAILED, {
                plan_id: action.meta?.arg?.plan_id,
                error: action.payload?.message || "Payment failed",
            })
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
};
